import {
  FixedAssetRegistryStartingBalanceActionTypes,
  FixedAssetRegistryStartingBalanceStateTypes,
} from "./FixedAssetRegistryStartingBalance.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: FixedAssetRegistryStartingBalanceStateTypes = {
  fetchAll: resetApiCallState([]),
  bulkUpsert: resetApiCallState({}),
};

const FixedAssetRegistryStartingBalanceReducer = (
  state: FixedAssetRegistryStartingBalanceStateTypes = INITIAL_STATE,
  action: any
): FixedAssetRegistryStartingBalanceStateTypes => {
  switch (action.type) {
    case FixedAssetRegistryStartingBalanceActionTypes
      .FETCH_ALL_FIXED_ASSET_REGISTRY_STARTING_BALANCE:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case FixedAssetRegistryStartingBalanceActionTypes
      .FETCH_ALL_FIXED_ASSET_REGISTRY_STARTING_BALANCE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case FixedAssetRegistryStartingBalanceActionTypes
      .FETCH_ALL_FIXED_ASSET_REGISTRY_STARTING_BALANCE_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FixedAssetRegistryStartingBalanceActionTypes
      .FETCH_ALL_FIXED_ASSET_REGISTRY_STARTING_BALANCE_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case FixedAssetRegistryStartingBalanceActionTypes
      .BULK_UPSERT_FIXED_ASSET_REGISTRY_STARTING_BALANCE:
      return {
        ...state,
        bulkUpsert: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case FixedAssetRegistryStartingBalanceActionTypes
      .BULK_UPSERT_FIXED_ASSET_REGISTRY_STARTING_BALANCE_RESET:
      return {
        ...state,
        bulkUpsert: resetApiCallState({}),
      };
    case FixedAssetRegistryStartingBalanceActionTypes
      .BULK_UPSERT_FIXED_ASSET_REGISTRY_STARTING_BALANCE_FAILURE:
      return {
        ...state,
        bulkUpsert: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FixedAssetRegistryStartingBalanceActionTypes
      .BULK_UPSERT_FIXED_ASSET_REGISTRY_STARTING_BALANCE_SUCCESS:
      return {
        ...state,
        bulkUpsert: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default FixedAssetRegistryStartingBalanceReducer;
